import React, { useEffect } from 'react'

import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@nextui-org/modal'
import { Button, Divider, Listbox, ListboxItem } from '@nextui-org/react'
import { useAccount, useDisconnect, useSwitchChain } from 'wagmi'
import Image from 'next/image'
import { useWallets } from '@privy-io/react-auth'

import ICONS from '@/assets/icons'
import SVGS from '@/assets/svgs'

import styles from './styles.module.css'

export const ModalSwitchNetwork = () => {
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure()
  const { chains } = useSwitchChain()
  const { isConnected, chainId } = useAccount()
  const { disconnect, isPending, isSuccess } = useDisconnect()
  const { wallets } = useWallets()
  const wallet = wallets[0]

  const renderIcon = (name: string) => {
    switch (name) {
      case 'BNB':
        return SVGS.binance
      case 'Ether':
        return SVGS.eth
      case 'BERA Token':
        return SVGS.bera
    }
  }

  useEffect(() => {
    if (!isConnected) return
    if (chainId) {
      const activeChain = chains.map((it) => it.id)?.includes(chainId)
      if (!activeChain) {
        onOpen()
      } else {
        onClose()
      }
    }
  }, [chainId, isConnected])

  useEffect(() => {
    if (isSuccess) {
      onClose()
    }
  }, [isSuccess])

  const handleChangeChainWallet = async (_chainId: number) => {
    try {
      await wallet.switchChain(_chainId)
    } catch (e) {
      console.error('Switch network failed', e)
    }
  }
  return (
    <div>
      <Modal
        className="bg-ss-dark max-h-[100svh]"
        size="sm"
        scrollBehavior="inside"
        isOpen={isOpen}
        classNames={{
          base: 'overflow-visible max-md:h-[100%] max-h-[100%]] text-white',
        }}
        hideCloseButton={true}
        onOpenChange={onOpenChange}
        isDismissable={false}
        backdrop="blur"
      >
        <ModalContent>
          <ModalHeader className="justify-center">
            <span>Switch Network</span>
          </ModalHeader>
          <ModalBody className="pb-6">
            <p className="text-sm text-center text-ss-grayscale-500">
              This app doesn’t support your current network. Switch to an available option to continue.
            </p>

            <Listbox aria-label="Listbox menu with descriptions" variant="flat">
              {chains.map((it) => (
                <ListboxItem
                  onClick={() => handleChangeChainWallet(it.id)}
                  key={it.id}
                  startContent={
                    <div className="border border-white/10 rounded-full">
                      <Image alt="" width={30} height={30} src={renderIcon(it.nativeCurrency?.name)} />
                    </div>
                  }
                >
                  <span className="text-base">{it.name} </span>
                </ListboxItem>
              ))}
            </Listbox>
          </ModalBody>
          <div className="flex items-center gap-5">
            <Divider className="flex-1" />
            <span className="text-sm text-ss-grayscale-500">or</span>
            <Divider className="flex-1" />
          </div>
          <ModalFooter>
            <Button
              isLoading={isPending}
              onClick={() => disconnect()}
              startContent={<Image className={styles.custom_icon_signout} src={ICONS.signOut} alt="" />}
              className="w-full bg-white/10 text-ss-grayscale-500"
              size="lg"
            >
              Disconnect
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}
